export function isGlobalSurveySuppressed(
    pathname: string,
    search: string,
): boolean {
    const isGuidedOnboarding =
        pathname.startsWith("/onboarding") ||
        new URLSearchParams(search).get("onboarding") === "1";

    return (
        isGuidedOnboarding ||
        pathname === "/upload" ||
        /^\/sessions\/[^/]+$/.test(pathname)
    );
}
